import { AfterContentInit, Component, ContentChildren, Input } from '@angular/core';
import { FcpAccordionItemComponent } from './fcp-accordion-item.component';

@Component({
    selector: 'fcp-accordion',
    templateUrl: './fcp-accordion.component.html',
    styleUrls: ['./fcp-accordion.component.less'],
    standalone: false
})
export class FcpAccordionComponent implements AfterContentInit {
    @Input() multiOpen = false;

    @ContentChildren(FcpAccordionItemComponent)
    private items: FcpAccordionItemComponent[];

    ngAfterContentInit() {
        this.items.forEach((item) => {
            item.toggleOpen.subscribe(() => {
                this.toggleItemState(item);
            });
        });
    }

    private toggleItemState(item: FcpAccordionItemComponent) {
        if (item.isOpen) {
            return (item.isOpen = false);
        }
        this.openItem(item);
    }

    private openItem(item) {
        if (!this.multiOpen) {
            this.closeAll();
        }
        item.isOpen = !item.isOpen;
    }

    private closeAll() {
        this.items.forEach((item) => {
            item.isOpen = false;
        });
    }
}
